import { createContext, useContext } from 'react'

import { noop } from '@/lib/utils'

export interface HeaderState {
  title: string
  setTitle: (title: string) => void
  showQuickSelection: boolean
  setShowQuickSelection: (show: boolean) => void
  isFullPage: boolean
  setIsFullPage: (isFullPage: boolean) => void
}

export const HeaderContext = createContext<HeaderState>({
  title: '',
  setTitle: noop,
  showQuickSelection: true,
  setShowQuickSelection: noop,
  isFullPage: false,
  setIsFullPage: noop,
})

export function useHeaderContext() {
  return useContext(HeaderContext)
}